<script setup lang="ts">
import Button from '../design-system/button.vue';

const props = defineProps({
  isActive: Boolean,
  redirectPath: String,
  spinCount: Number,
});
</script>

<template>
  <NuxtLink
    :id="`jpc-spin-now-nav-item`"
    :to="props.redirectPath"
    class="relative hidden md:block"
  >
    <Button
      class="flex-col !w-full md:!w-fit"
      :type="props.isActive ? 'primary' : 'transparent'"
      rounding="md"
      padding="md"
    >
      <DesignSystemIconsExternalIcon icon-name="jpc-spin-now" class="w-6 h-6" />
      <span class="capitalize w-full text-xxs truncate text-ellipsis">
        {{ $t('jpc-spin-now') }}
      </span>
      <span
        class="badge animate-pulse absolute bg-blue-500 rounded-full top-0.5 right-0.5 text-light-50 w-4 h-4 flex-center"
      >
        <span
          class="mx-auto text-center w-full font-bold text-xs tracking-wide"
        >
          {{ props?.spinCount }}
        </span>
      </span>
    </Button>
  </NuxtLink>
</template>
